import { Injectable } from '@angular/core';
import { App } from "ionic-angular";

@Injectable()
export class NavService {

  constructor(private app: App) {
  }

  /**
   * 遷移処理
   * @param page string
   * @return void
   */
  goTo(page: string): void {
    let nav = this.app.getActiveNavs();
    nav[0].setRoot(page);
  }

}



// WEBPACK FOOTER //
// ./src/providers/nav.service.ts